import _ from 'lodash';
import React, { useEffect, useState, useContext } from 'react';
import { FormInputContainer, FormContext } from 'blaze-form';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import DealContext from './DealContext';
import ApiService from '../../services/ApiService';
import { modal } from '../modal/ModalEmitter';

const FormInputCustomerSaleSelection = ({ onChange, ...props }) => {
  const { deal } = useContext(DealContext);

  const [customer, setCustomer] = useState(null);

  // Loading vars
  const [fetchingCustomer, setFetchingCustomer] = useState(true);

  // const quoteId = manager.itemId;

  const fetchCustomer = customerId => {
    if (!customerId) {
      return;
    }

    setFetchingCustomer(true);
    return ApiService.get(`crm/customer/${encodeURIComponent(customerId)}`)
      .then(response => {
        setCustomer(response.data);
      })
      .finally(() => {
        setFetchingCustomer(false);
      });
  };

  const handleClickCard = () => {
    modal.open('customerDetail', { lookupKey: deal.customerId });
  };

  useEffect(() => {
    if (customer) {
      // stuff
    }
  }, [customer]);

  useEffect(() => {
    if (customer && deal.customerId !== customer.itemid) {
      fetchCustomer(deal.customerId);
    }
  }, [deal]);

  useEffect(() => {
    fetchCustomer(props.value);
  }, []);

  if (fetchingCustomer) {
    return (
      <Card className="mb-3" style={{ height: '119px' }}>
        <Card.Body style={{ padding: '1rem' }}>
          <Skeleton className="ml-1" style={{ width: '20px', float: 'right' }} />
          <Skeleton style={{ width: '20px', float: 'right' }} />
          <Skeleton style={{ width: '50%' }} />
          <Skeleton style={{ width: '75%' }} />
          <Skeleton style={{ width: '40%' }} />
        </Card.Body>
      </Card>
    );
  }

  return (
    <FormInputContainer>
      {customer && (
        <Card className="vehicle-select-data" onClick={handleClickCard} style={{ cursor: 'pointer' }}>
          <div className="card-heading">Customer</div>
          <Card.Body style={{ padding: '1rem' }}>
            {customer.fullName || customer['Company Name']}
            <br />
            {customer.Address}
            <br />
            {customer.City} {customer.State} {customer.Zip}
            <br />
            {customer.Phone}
          </Card.Body>
        </Card>
      )}
    </FormInputContainer>
  );
};

export default FormInputCustomerSaleSelection;
